<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{title}}</h2>

<mat-dialog-content [ngClass]="{ 'no-spinner': !isSpinner }">
    <ng-container *ngIf="isAddNew">
        <div style="display: flex;align-items: center;gap: 7px;padding-top: 5px;">
            <span class="symbolbox" [style.color]="viewModel.currentColor.color">{{symbol}}</span>
            <mat-form-field #textboxmatform class="mat-form-field-no-padding" appearance="outline" floatLabel="always" style="max-width: 210px;margin-right: 5px;">
                <mat-label>{{label}}</mat-label>
                <ng-container *ngIf="isPositiveInteger; else defaultfind">
                    <input type="number" id="add-input" cdkFocusInitial  style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.currentValue" placeholder="{{placeholder}}" [min]="0" [max]="1000">
                </ng-container>
                <ng-template #defaultfind>
                    <input type="number" id="add-input" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.currentValue" placeholder="{{placeholder}}">
                </ng-template>
                <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
            </mat-form-field>
            <button title="Add" (click)="addItem()" mat-icon-button style="margin-top: -8px;margin-left: -10px;">
                <mat-icon class="icon" color="primary">add_box</mat-icon>
                
            </button>
        </div>
        <div class="dashed-line"></div>
    </ng-container>

    <div *ngIf="isShowHeader" style="display: flex; padding-bottom: 5px;">
        <span style="flex: 1;">Source Field</span>
        <span style="flex: 2;margin-left: 50px;">Value</span>
    </div>
    <!-- Fields Section -->
    <ng-container *ngFor="let item of viewModel.textItems;let i = index">
        <div style="display: flex; align-items: center; gap: 5px;padding-top: 5px;">
            <!-- Colored Source Field Name -->
            <span *ngIf="isShowHeader" style="flex: 1;" [style.color]="viewModel.sourceItems[i]?.color">
                {{ viewModel.sourceItems[i]?.text }}
            </span> 
            <div style="font-size: 12pt;">
                {{symbol}}
            </div>
            <!-- Input Field -->
            <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="auto" style="flex: 2; max-width: 210px;margin-right: 10px;">
                <mat-label>{{label}}</mat-label>
                <ng-container *ngIf="isPositiveInteger; else default">
                    <input type="number" id="add-input" cdkFocusInitial  style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.text" placeholder="Enter numeric value" required appIntegerPositiveOnly>
                </ng-container>
                <ng-template #default>
                    <input type="number"  id="add-input" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.text" placeholder="Enter numeric value" required>
                </ng-template>
                <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
            </mat-form-field>
            <ng-container *ngIf="isAddNew">
                <button mat-icon-button style="margin-left: -17px;" (click)="deleteItem(item)">
                    <mat-icon class="icon red-icon" >delete_forever</mat-icon>
                </button>
            </ng-container>
        </div>
    </ng-container>
    <div *ngIf="!isShowHeader">
        <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
            *ngFor="let containItem of viewModel.sourceItems"
            [style.color]="containItem.color.color">{{containItem.text }} </span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()" class="save-btn" color="primary" mat-raised-button >SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close >CANCEL</button>
</mat-dialog-actions>
</div>